import React, { useEffect, useState } from "react";
import Button from "../../../components/Button/Button";
import { useSelection } from "../../../contexts/SelectionContext";
import { useTranslation } from "../../../contexts/TranslationProvider";
import "./Delete.action.scss";

const DeleteAction = ({ triggerAction, onDelete, isHideMode = true }) => {
  const [deleteMsg, setDeleteMsg] = useState("");
  const { selectedFiles, setSelectedFiles } = useSelection();
  const t = useTranslation();

  useEffect(() => {
    const updateDeleteMessage = () => {
      if (selectedFiles.length === 1) {
        const file = selectedFiles[0];
        if (isHideMode) {
          // Режим скрытия
          const action = file.isDirectory ? "скрыть папку" : "скрыть файл";
          return `Вы уверены, что хотите ${action} "${file.name}"?`;
        } else {
          // Обычное удаление
          return t("deleteItemConfirm", { fileName: file.name });
        }
      } else if (selectedFiles.length > 1) {
        if (isHideMode) {
          const folderCount = selectedFiles.filter(f => f.isDirectory).length;
          const fileCount = selectedFiles.length - folderCount;
          let message = `Вы уверены, что хотите скрыть ${selectedFiles.length} элементов?`;
          if (folderCount > 0) {
            message += ` (${folderCount} папок и ${fileCount} файлов)`;
          }
          return message;
        } else {
          return t("deleteItemsConfirm", { count: selectedFiles.length });
        }
      }
      return "";
    };

    setDeleteMsg(updateDeleteMessage());
  }, [selectedFiles, t, isHideMode]);

  const handleDeleting = () => {
    if (onDelete) {
      onDelete(selectedFiles);
    }
    setSelectedFiles([]);
    triggerAction.close();
  };

  const getButtonText = () => {
    if (isHideMode) {
      return selectedFiles.length === 1 
        ? (selectedFiles[0]?.isDirectory ? "Скрыть папку" : "Скрыть файл")
        : "Скрыть все";
    }
    return t("delete");
  };

  const getWarningMessage = () => {
    if (!isHideMode) return null;
    
    const hasFolders = selectedFiles.some(f => f.isDirectory);
    
    return (
      <div className="hide-warning-message">
        <small style={{ color: '#dc3545', display: 'block', marginTop: '10px' }}>
          ⚠️ Внимание: Элементы будут скрыты только для вас.
          {hasFolders && ' Содержимое папок также будет скрыто.'}
          На сервере файлы останутся нетронутыми.
        </small>
      </div>
    );
  };

  return (
    <div className="file-delete-confirm">
      <p className="file-delete-confirm-text">{deleteMsg}</p>
      
      {getWarningMessage()}
      
      <div className="file-delete-confirm-actions">
        <Button type="secondary" onClick={() => triggerAction.close()}>
          {t("cancel") || "Отмена"}
        </Button>
        <Button 
          type="danger" 
          onClick={handleDeleting}
          style={{
            backgroundColor: isHideMode ? '#dc3545' : '#f44336',
            borderColor: isHideMode ? '#dc3545' : '#f44336'
          }}
        >
          {getButtonText()}
        </Button>
      </div>
    </div>
  );
};

export default DeleteAction;